

const SkeltonProviderRow = () => {
    return (
        <>
            {
                Array.from(Array(10)).map((item, index) => {
                    return (
                        <tr
                            data-testid="provider-skeleton-row"
                            className="animate-pulse border-b border-edge-faint last:border-b-0"
                            key={index}
                        >
                            <td className="py-3 pl-1 pr-4">
                                <div className="h-4 bg-overlay-mid rounded w-[70%]"></div>
                                <div className="h-3.5 bg-overlay-mid rounded w-[45%] mt-2"></div>
                            </td>
                            {Array.from(Array(10)).map((cell, cellIndex) => (
                                <td className="py-3 px-1" key={cellIndex}>
                                    <div className="h-8 w-8 mx-auto rounded-lg bg-overlay-mid"></div>
                                </td>
                            ))}
                            <td className="py-3 pr-1">
                                <div className="h-8 w-8 ml-auto rounded-lg bg-overlay-mid"></div>
                            </td>
                        </tr>
                    )
                })
            }
        </>
    )
}

export default SkeltonProviderRow
